import { SendWorkSafeBcFormStrategy } from "@/Patient/Services/Portal/Strategies/SendWorkSafeBCFormStrategy";
import { PortalPopupModel } from "@/Portal/Models/PortalPopupModel";
import { ISharedItemProvider } from "@/Portal/Services/ISharedItemProvider";
import { BaseSendMedicalNoteItemToPortalPopupStrategy } from "@/Portal/Services/Strategies/BaseSendMedicalNoteItemToPortalPopupStrategy";

class WorkSafeBcFormSharedItemProvider implements ISharedItemProvider {
    public getSharedItemTypeLabel(): string {
        return cacheStore.GetString("FormLabel");
    }

    public getItemIconClass(): string {
        return "requestIcon";
    }

    public shouldShowFilePreviewInPortfolio(): boolean {
        return true;
    }

    public createSendMedicalNoteItemToPortalPopupStrategy(portalPopupModel: PortalPopupModel, onSignatureAccepted: () => void): BaseSendMedicalNoteItemToPortalPopupStrategy | null {
        return new SendWorkSafeBcFormStrategy(portalPopupModel, () => onSignatureAccepted());
    }

    public getPinFrequencyToken(): string {
        return "";
    }

    public getPinFrequencyDocumentType(): null {
        return null;
    }
}

export { WorkSafeBcFormSharedItemProvider };
